export default __webpack_public_path__ + "static/media/Likitha_Mark.a3975707.jpeg";